import FilterControlSelect from './FilterControlSelect';
import FilterControlRange from './FilterControlRange';
import FilterControlChartingInterval from './FilterControlChartingInterval';
import React, { Fragment } from 'react';
import { Box, Tooltip } from '@mui/material';
import { StaticAddon } from 'components/common/static-addon/StaticAddon';
import { IFilterColumn } from 'components/report-content/components/manage-filters';

export default function FilterControl({
    filter,
    handleFilterChange,
}: {
    filter: IFilterColumn;
    handleFilterChange: (filter: IFilterColumn, value: any) => void;
}) {
    let isDouble = false;
    let component: any = 'Component not FOUND: ' + filter.filterType;
    switch (filter.filterType) {
        case 'multiselect':
        case 'dropdown':
            component = <FilterControlSelect filter={filter} onChange={(value) => handleFilterChange(filter, value)} />;
            break;
        case 'range':
            isDouble = true;
            component = <FilterControlRange filter={filter} onChange={(value) => handleFilterChange(filter, value)} />;
            break;
        case 'charting_interval':
            component = (
                <FilterControlChartingInterval
                    filter={filter}
                    onChange={(value) => handleFilterChange(filter, value)}
                />
            );
    }

    if (isDouble) {
        return <Fragment key={filter.column_name}>{component}</Fragment>;
    }

    return (
        <Box
            sx={{
                width: '264px',
                display: 'inline-flex',
                m: 0.75,
            }}
            key={filter.column_name}
        >
            <StaticAddon sx={{ maxWidth: '110px' }}>
                <Tooltip placement="bottom-start" enterDelay={1000} title={filter.column_name}>
                    <span>{filter.column_name}</span>
                </Tooltip>
            </StaticAddon>
            {component}
        </Box>
    );
}
